import { atomWithStorage } from 'jotai/utils';

// storageに `suid` として書き込まれる
// 保存される値は自動的に JSON.stringify() される
// 管理ユーザー用
export const selectedUserIdAtom = atomWithStorage<string>('suid', '');
